import devRoutesModule from './devRoutes.js'

const devRoutes = process.env.NODE_ENV === 'production' ? [] : devRoutesModule.default

export default devRoutes
